<dialog
  #dialog
  class="esn-dialog"
  [class.esn-dialog--inline]="inline()"
  role="alertdialog"
  [attr.aria-labelledby]="titleId"
  [attr.aria-describedby]="bodyId"
  (cancel)="handleCancel($event)"
  (click)="handleClick($event)"
>
  <div class="esn-dialog__panel">
    <header class="esn-dialog__header">
      <esn-icon [name]="icon()" [size]="24" />
      <h2 class="esn-dialog__title" [id]="titleId">{{ title() }}</h2>
    </header>
    <div class="esn-dialog__body" [id]="bodyId">
      @if (body()) {
        <p>{{ body() }}</p>
      }
      <ng-content />
    </div>
    @if (confirmText() != null) {
      <esn-text-field
        [label]="confirmFieldLabel()"
        [hint]="confirmHint()"
        autocomplete="off"
        [value]="typed()"
        (valueChange)="typed.set($event)"
      />
    }
    <footer class="esn-dialog__footer">
      <esn-button variant="secondary" (clicked)="dismiss('close')">{{ cancelLabel() }}</esn-button>
      <esn-button [variant]="confirmVariant()" [disabled]="!armed()" (clicked)="handleConfirm()">{{ confirmLabel() }}</esn-button>
    </footer>
  </div>
</dialog>
